import {NavController, ViewController, AlertController, LoadingController, NavParams} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";

@Component({
    templateUrl: 'personMsgView.html',
    // providers: [UserService, AppConfigService]
})
export class PersonMsgViewPage {
    content: string;
    uid: string;
    title: string = "Chi tiết tin nhắn";

    constructor(public params: NavParams, public loadingCtrl: LoadingController, private viewCtrl: ViewController, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService) {
        this.uid = params.get("data");
        this.initData();
    }

    initData() {
        let postData = {
            id: this.uid
        };
        this.userService.personMessageView(postData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.content = data["viewmsg"]["content"];
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/personMsgView/personMsgView.ts